export enum Domain {
  SALES = "SALES",
  DELIVERY = "DELIVERY",
  CENTRAL_FUNCTIONS = "CENTRAL_FUNCTIONS",
}
